import styles from "./style.module.css";
import React, { useEffect } from "react";
import { useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import dataContext from "../../../../context/dataContext";
import mainContext from "../../../context/mainContext";

import Input from "../../../components/Common/Input/Input";
import Button from "../../../components/Common/Button";
import Underline from "../../../assets/images/icons/UnderLine.png";
import trainReadingRequests from "../../../components/api/trainReadingRequests";
import userRequests from "../../../components/api/userRequests";
import dataContext from "../../../context/dataContext";

export default function ExerciseQuestion() {
  // const user = useContext(dataContext);
  const { header, loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext);
  const { userDetails, setUserDetails } = useContext(dataContext)
  useEffect(() => {
    header.setPageName("FINE-TUNING JOURNAL");
  }, []);

  const navigate = useNavigate();

  const { state } = useLocation();
  const LPM_Value = state.LPM_Pushup;
  const justRight = state.JustRight;
  const newLPM = state.New_LPM;
  const round = state.roundExercise;
  console.log("🚀 ~ file: ExerciseQuestion.jsx:31 ~ ExerciseQuestion ~ round:", round)
  const clickedButton = state.ClickedButton;
  const formInfo2 = state.formInfo ? [...state.formInfo] : [];

  const [vq1, setVq1] = useState(true);
  const [q1, setQ1] = useState("");

  const [vq2, setVq2] = useState(true);
  const [q2, setQ2] = useState("");

  const [vq3, setVq3] = useState(true);
  const [q3, setQ3] = useState("");

  const [vq4, setVq4] = useState(true);
  const [q4, setQ4] = useState("");
  const [vq5, setVq5] = useState(true);
  const [q5, setQ5] = useState(localStorage.Epage ? localStorage.Epage : "");
  const [vq6, setVq6] = useState(true);
  const [q6, setQ6] = useState("");
  useEffect(() => {
    console.log('Initial states:');
    console.log({ vq1, q1, vq2, q2, vq3, q3, vq4, q4, vq5, q5, vq6, q6 });
  }, []);
  function validForm() {
    console.log({ vq1, q1, vq2, q2, vq3, q3, vq4, q4, vq5, q5, vq6, q6 });
    if (q1.trim().length == 0) {
      setVq1(false);
    } else if (q2.trim().length == 0) {
      setVq2(false);
    } else if (q3.trim().length == 0) {
      setVq3(false);
    } else if (q4.trim().length == 0) {
      setVq4(false);
    } else if (q5.trim().length == 0) {
      setVq5(false);
    } else if (q6.trim().length == 0) {
      setVq6(false);
    } else {
      round === 1
        ? (objProps.formInfo = [
          {
            round,
            answer:
            {
              1: `${q1}`,
              2: `${q2}`,
              3: `${q3}`,
              4: `${q4}`,
              5: `${q5}`,
              6: `${q6}`,
            },
          }
        ])
        : (objProps.formInfo = [
          ...formInfo2,
          {
            round,
            answer: {
              1: `${q1}`,
              2: `${q2}`,
              3: `${q3}`,
              4: `${q4}`,
              5: `${q5}`,
              6: `${q6}`,
            },
          }

        ]);
      if (
        justRight ||
        round === 3 ||
        (round > 1 && clickedButton[round - 1] !== clickedButton[round - 2])
      ) {
        // console.log("SENDING OBJ TO RESULT");
        let ans = { level: [], pushUp: [] };
        // Object.keys(objProps.formInfo[1]).forEach((key, index) => {
        //   ans.level.push(objProps.formInfo[1]["answer"]);
        // });
        objProps.formInfo.map(value => ans.level.push(value.answer))
        state.questions.map(value => ans.pushUp.push(value.answer));
        let res = {
          bookName: state.bookName || objProps.BookName,
          genre: state.genre || "Genre",
          answers: ans,
          value: state.New_LPM,
        };
        setLoaderFetch(true);
        userRequests.addNewTr(res, userDetails)
          .then((response) => { setUserDetails(response); console.log("details after pushup", response) })
          .catch((e) => console.log("eror tr", e))
          .finally(() => {
            setLoaderFetch(false);
            navigate("/train-reading/result", { state: { ...state, ...objProps } })
          })

      } else {
        // console.log("SENDING OBJ TO EXERCISE");
        navigate("/train-reading/exercise-clock", { state: { ...state, ...objProps } });
      }
    }
  }
  const objProps = {
    LPM_Pushup: state.LPM_Pushup,
    New_LPM: newLPM,
    roundExercise: state.roundExercise,
    ClickedButton: state.ClickedButton,
    BookName: state.BookName,
    fromPath: "tr/question",
  };

  function startFunction() {
    navigate("/train-reading/exercise-clock", { state: objProps });
  }

  return (
    <div className="container" style={{ flexGrow: 1, overflowY: "scroll" }}>      {/* //TODO:majorCSSChange */}
      {/* <div className={styles.nTitle}>Journal Questions:</div> */}
      <div className={styles.QTitle}>What did you see? What did you feel?</div>
      {1 && <div className={styles.bookTitle}>{state.bookName}</div>}
      <div className={styles.nUnderLine}>
        <img src={Underline} alt="underline" />
      </div>
      <div className={styles.fourQues} style={window.buildType === "iPhone" ? { height: "67vh" } : {}} >
        <div className={styles.pageRangeContainer}>
          <div>

            <Input name={"5"} legend={"From Page"} type="number" defaultValue={localStorage.Epage ? localStorage.Epage : ""} content="Num." valid={vq5} onInput={(e) => { setVq5(true); setQ5(e.target.value); }} />
          </div>
          <div>

            <Input name={"6"} legend={"To Page"} type="number" content="Num." valid={vq6} onInput={(e) => { setVq6(true); setQ6(e.target.value); }} />
          </div>
        </div>
        <Input
          legend={"Who?"}
          type="text"
          content={"Describe Here"}
          valid={vq1}
          onInput={(e) => {
            setVq1(true);
            setQ1(e.target.value);
          }}
        />
        <Input
          legend={"What?"}
          type="text"
          content={"Describe Here"}
          valid={vq2}
          onInput={(e) => {
            setVq2(true);
            setQ2(e.target.value);
          }}
        />
        <Input
          legend={"Where?"}
          type="text"
          content={"Describe Here"}
          valid={vq3}
          onInput={(e) => {
            setVq3(true);
            setQ3(e.target.value);
          }}
        />
        <Input
          legend={"When?"}
          type="text"
          content={"Describe Here"}
          valid={vq4}
          onInput={(e) => {
            setVq4(true);
            setQ4(e.target.value);
          }}
        />
      </div>
      <div className={styles.EQButton}>
        <Button
          fontColor="#fff"
          bgColor="#F39C12"
          startFunction={validForm}
          title="DONE"
        />
      </div>
    </div>
  );
}
